// extracted by mini-css-extract-plugin
export var button = "style-module--button--2T9L7";
export var container = "style-module--container--jswGz";
export var headline = "style-module--headline--TEH1Y";
export var imagecontainer = "style-module--imagecontainer--S2uTp";
export var imglyTypoButton = "style-module--imgly--typo-button--CiHcr";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--m6U8z";
export var imglyTypoH1 = "style-module--imgly--typo-h1--M5LWf";
export var imglyTypoH2 = "style-module--imgly--typo-h2--Jxy6T";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--uHLYg";
export var imglyTypoH3 = "style-module--imgly--typo-h3--U6Agu";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--m8bhZ";
export var imglyTypoH4 = "style-module--imgly--typo-h4--hnaxa";
export var imglyTypoH5 = "style-module--imgly--typo-h5--bKVY2";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--QzsTt";
export var imglyTypoIcon = "style-module--imgly--typo-icon--C58-b";
export var imglyTypoLink = "style-module--imgly--typo-link--CuMpV";
export var imglyTypoOverline = "style-module--imgly--typo-overline--IuYYx";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--E+ko4";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--uL8Q3";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--1IQfH";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--3a6-G";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--FgTfh";
export var imglyTypoSubline = "style-module--imgly--typo-subline--6FHdL";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--wuo4E";
export var naviLabelIsLarge = "style-module--navi-label-is-large--Xhnon";
export var naviLabelIsSmall = "style-module--navi-label-is-small--X5f6S";
export var root = "style-module--root--g+gUO";
export var section = "style-module--section--1ncU4";
export var subline = "style-module--subline--JNGC8";
export var supportdesk = "style-module--supportdesk--hOI+u";